export const experienceData = [
  {
    id: 1,
    company: "Sprilio Tech",
    jobtitle: "SDE-2",
    startYear: "July-2025",
    endYear: "Present",
  },
  {
    id: 2,
    company: "Sprilio Tech",
    jobtitle: "SDE-1",
    startYear: "July-2023",
    endYear: "July-2025",
  },
  {
    id: 3,
    company: "Fynd",
    jobtitle: "Intern",
    startYear: "Dec-2022",
    endYear: "May-2023",
  },
];
